<footer class="premium-footer">
  <div class="footer-container">
    <div class="footer-main">
      <div class="footer-brand">
        <div class="brand-logo">
          <div class="logo-icon">🎓</div>
          <div class="brand-info">
            <h3 class="brand-name">Tenjah School</h3>
            <span class="brand-tagline">Excellence in Education</span>
          </div>
        </div>
        <p class="footer-description">
          Empowering the next generation of learners through innovative digital education
          and personalized learning experiences that inspire academic excellence.
        </p>

      </div>
      <div class="footer-links">
        <div class="link-group">
          <h4 class="group-title">Platform</h4>
          <a href="#" class="footer-link">Features</a>
          <a href="#" class="footer-link">Pricing</a>
          <a href="#" class="footer-link">Security</a>
          <a href="#" class="footer-link">Integrations</a>
        </div>
        <div class="link-group">
          <h4 class="group-title">Company</h4>
          <a href="#" class="footer-link">About Us</a>
          <a href="#" class="footer-link">Careers</a>
          <a href="#" class="footer-link">Blog</a>
          <a href="#" class="footer-link">Press Kit</a>
        </div>
        <div class="link-group">
          <h4 class="group-title">Legal</h4>
          <a href="#" class="footer-link">Privacy Policy</a>
          <a href="#" class="footer-link">Terms of Service</a>
          <a href="#" class="footer-link">Cookie Policy</a>
          <a href="#" class="footer-link">GDPR</a>
        </div>

        <!-- Social & Contact Section -->
        <div class="link-group social-contact-column">
          <!-- Follow us Section -->
          <div class="follow-us-section">
            <h4 class="group-title">Follow us</h4>
            <div class="social-links">
              <a href="{{ contactInfo.socialMedia.facebook }}" class="social-link" aria-label="Facebook">
                <i class="fab fa-facebook"></i>
              </a>
              <a href="{{ contactInfo.socialMedia.youtube }}" class="social-link" aria-label="YouTube">
                <i class="fab fa-youtube"></i>
              </a>
              <a href="{{ contactInfo.socialMedia.instagram }}" class="social-link" aria-label="Instagram">
                <i class="fab fa-instagram"></i>
              </a>
            </div>
          </div>

          <!-- Separator Line -->
          <div class="separator-line"></div>

          <!-- Contact us Section -->
          <div class="contact-us-section">
            <h4 class="group-title">Contact us</h4>
            <div class="contact-info">
              <div class="contact-item">
                <i class="fas fa-phone"></i>
                <span>{{ contactInfo.phone }}</span>
              </div>
              <div class="contact-item">
                <i class="fas fa-envelope"></i>
                <span>{{ contactInfo.email }}</span>
              </div>
              <div class="contact-item">
                <i class="fas fa-map-marker-alt"></i>
                <span>{{ contactInfo.address }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="bottom-content">
        <p class="copyright">
          © 2024 Tenjah School. All rights reserved.
        </p>
        <div class="bottom-links">
          <a href="#" class="bottom-link">Privacy</a>
          <a href="#" class="bottom-link">Terms</a>
          <a href="#" class="bottom-link">Support</a>
        </div>
      </div>
    </div>
  </div>
</footer>